import React from 'react';
import moment from 'moment';
import { formatDateAndTime } from '../../../function/Helper';

interface IProps {
  enquiryInfo: any;
}

const SpecificEnquiryDetails = (props: IProps) => {
  const { enquiryInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      <div className="flex justify-between items-center">
        <div className="flex gap-12">
          <label className="text-xs md:text-sm text-white font-bold">Enquiry ID</label>
          <label className="text-xs md:text-sm text-white font-normal">
            {enquiryInfo.enquiryId}
          </label>
        </div>
      </div>

      <div className="flex gap-[32px]">
        <label className="text-xs md:text-sm text-white font-bold">Created Date</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {/* {moment(enquiryInfo.createdAt).local().format('L')} */}
          {formatDateAndTime(enquiryInfo.createdAt)}
        </label>
      </div>

      <div className="flex gap-[80px]">
        <label className="text-xs md:text-sm text-white font-bold">Name</label>
        <label className="text-xs md:text-sm text-white font-normal break-all">{enquiryInfo.name}</label>
      </div>

      <div className="flex gap-[83px]">
        <label className="text-xs md:text-sm text-white font-bold">Email</label>
        <label className="text-xs md:text-sm text-white font-normal">{enquiryInfo.email}</label>
      </div>

      <div className="flex gap-[43px]">
        <label className="text-xs md:text-sm text-white font-bold">Description</label>
        <label className="text-xs md:text-sm text-white font-normal  break-all">
          {enquiryInfo.description}{' '}
        </label>
      </div>
    </div>
  );
};

export default SpecificEnquiryDetails;
